document.addEventListener('DOMContentLoaded', () => {
    const menu = document.querySelector('.wcl-header-menu');
    const open = document.querySelector('.wcl-header .burger');
    const close = document.querySelector('.wcl-header-menu .close');

    if ( !menu && !open && !close ) return;

    open.addEventListener('click', e => {
        e.preventDefault();

        menu.classList.add('active')
    });

    close.addEventListener('click', e => {
        e.preventDefault();

        menu.classList.remove('active')
    });
});